/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  selector: 'ellf-checkboxlist-field',
  template: `
    <ellf-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
    >
      <ellf-checkboxlist
        [hasError]="shouldShowError"
        [formControl]="formControl"
        [items]="items"
      >
      </ellf-checkboxlist>
    </ellf-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxListFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckboxListFieldComponent extends BaseFormFieldComponent {
  @Input()
  items!: { id: string; description: string }[];

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.items) {
      throw new Error('items unspecified');
    }
  }
}
